export const CONTEXT_KEYS = {
  customers: 'customers',
  customer_delivery_to: 'customer_delivery_to',
  itineraries: 'itineraries',
}